@if(!loading()) {
<div class="pt-3">
    <i-title [text]="title()" [buttons]="buttons()" [hasBackIcon]="true" (iconClick)="cancel()"
        [subTitle]="currentPoint()?.title ?? ''"></i-title>

</div>
<div class="mt-3">
    <form [formGroup]="form" class="point-form">
        <div class="point-form__point-required-data card">
            <h4>{{'POINTS.FORM.SECTION_TITLE.POINT' | translate}}</h4>
            <div class="row mb-3">
                <div class="col-6">
                    <label for="title" class="input-label">
                        {{'POINTS.FORM.LABELS.TITLE' | translate}}*
                    </label>
                    <textarea name="title" formControlName="title" pInputTextarea [style]="{width: '100%'}"
                        [rows]="1"></textarea>
                    @if(form.get('title')?.hasError('nonEmptyString')) {
                    <idel-form-error [errorMessage]="'Le titre du point ne peut être vide'"></idel-form-error>
                    }
                </div>
                <div class="col-6">
                    <label for="status" class="input-label">
                        {{'POINTS.FORM.LABELS.STATUS' | translate}}*
                    </label>
                    <p-dropdown [autoDisplayFirst]="false" [options]="pointStatusesOptions()" [appendTo]="'body'"
                        formControlName="status" styleClass="w-100" name="status"
                        optionLabel="description"></p-dropdown>
                </div>
            </div>
            <div class="row">
                <div class="col-md-4 col-sm-12">
                    <label for="point-type" class="input-label">
                        {{'POINTS.FORM.LABELS.POINT_TYPE' | translate}}*
                    </label>
                    <p-dropdown [autoDisplayFirst]="false" [options]="pointTypesOptions()" [appendTo]="'body'"
                        formControlName="pointType" styleClass="w-100" name="pointType"
                        optionLabel="description"></p-dropdown>
                </div>
                <div class="col-md-4 col-sm-12">
                    <label for="matter" class="input-label">
                        {{'POINTS.FORM.LABELS.MATTER' | translate}}
                        @if(isMatterRequired) {
                        *
                        }
                    </label>
                    <p-dropdown [autoDisplayFirst]="false" [options]="mattersOptions()" [appendTo]="'body'"
                        formControlName="matter" styleClass="w-100" name="matter"
                        optionLabel="description"></p-dropdown>
                </div>
                <div class="col-md-4 col-sm-12">
                    <label for="aldermanship" class="input-label">
                        {{'POINTS.FORM.LABELS.ALDERMANSHIP' | translate}}
                        @if(isAldermanshipRequired) {
                        *
                        }
                    </label>
                    <p-dropdown [autoDisplayFirst]="false" [options]="aldermanshipsOptions()" [appendTo]="'body'"
                        formControlName="aldermanship" styleClass="w-100" name="aldermanship"
                        optionLabel="description"></p-dropdown>
                </div>
            </div>
        </div>
        <div class="point-form__meeting card">
            <h4>{{'POINTS.FORM.SECTION_TITLE.MEETING' | translate}}</h4>
            <div class="row">
                <div class="col-6">
                    <label for="meeting-type" class="input-label">
                        {{'POINTS.FORM.LABELS.MEETING_TYPE' | translate}}*
                    </label>
                    <p-dropdown [autoDisplayFirst]="false" [options]="meetingTypesOptions()" [appendTo]="'body'"
                        (onChange)="onMeetingTypeChange($event)" formControlName="meetingType" styleClass="w-100"
                        name="meetingType" optionLabel="description"></p-dropdown>
                </div>
                <div class="col-6">
                    <label for="meeting" class="input-label">
                        {{'POINTS.FORM.LABELS.MEETING' | translate}}*
                    </label>
                    <p-dropdown [placeholder]="meetingDropdownPlaceholder" [autoDisplayFirst]="false"
                        [loading]="fetchingMeetings()" [options]="meetingsOptions()" [appendTo]="'body'"
                        formControlName="meeting" styleClass="w-100" name="meeting"
                        optionLabel="description"></p-dropdown>
                </div>
            </div>
        </div>
        <div class="point-form__service card">
            <h4>{{'POINTS.FORM.SECTION_TITLE.SERVICE' | translate}}</h4>
        </div>
        <div class="point-form__other card">
            <h4>{{'POINTS.FORM.SECTION_TITLE.OTHER' | translate}}</h4>
        </div>
        <div class="point-form__classification card">
            <h4>{{'POINTS.FORM.SECTION_TITLE.CLASSIFICATION' | translate}}</h4>
        </div>
    </form>
</div>
}@else {
<div class="w-100 h-100 d-flex justify-content-center align-content-center pt-xxl-5">
    <i-loader></i-loader>
</div>
}